import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    manufacturerDeleteRequest,
    searchEntityRequest,
    clearRedux,
} from 'Redux/actions';

const CreateEditManufacturer = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        manufacturer,
        result,
    } = useSelector(state => state.deleteManufacturerRedux);

    const handleDelete = () => {
        dispatch(manufacturerDeleteRequest(manufacturer?.id))
    }

    const closeModal = () => {
        dispatch(clearRedux("MANUFACTURER_DELETE"))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['manufacturer_delete_success_message'],
                    messages['manufacturer_delete_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
                closeModal()
                dispatch(clearRedux("MANUFACTURER_DELETE", { result: null }))
            } else {
                let message = messages['manufacturer_delete_general_error']
                if (result && result?.error && result?.error?.includes("in use")) {
                    if (result?.error?.includes("Unit")) {
                        message = messages['manufacturer_delete_package_in_use_unit']
                    }
                    if (result?.error?.includes("DeviceModel")) {
                        message = messages['manufacturer_delete_package_in_use_device_model']
                    }
                    if (result?.error?.includes("UnitType")) {
                        message = messages['manufacturer_delete_package_in_use_unit_type']
                    }
                }

                NotificationManager.error(
                    message,
                    messages['manufacturer_delete_title'],
                    3000,
                );
                dispatch(clearRedux("MANUFACTURER_DELETE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['manufacturer_delete_title']} (${manufacturer?.name})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['manufacturer_delete_message']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleDelete}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditManufacturer;


